import { baseApiUrl, cloneDeep, showSuccess, showError } from '@/global'
import axios from 'axios'
const FormData = require('form-data');
const stringify = require('json-stringify-safe');

export default {
    namespaced: true,
    state: {
        tabActived: 0,
        loading: false,
        lastSnapshot: 0,
        automations: [],
        periodScopes: [
            {
                value: 'last24h',
                text: 'Últimas 24 horas'
            },
            {
                value: 'lastWeek',
                text: 'Última Semana'
            },
        ],
        periodScope: {
            value: 'last24h',
            text: 'Últimas 24 horas'
        },
        funnelsLast24h: [],
        funnelsLastWeek: [],
        campaignsLast24h: [],
        campaignsLastWeek: [],
        consult: [],
        downloads: [],
        downloadsStats: [],
        stats: [],
        users: [],
        logs: [],
        log: {},
        active: [],
        treports: [],
        status: [
            'Arquitetura',
            'Diagnóstico',
            'Em espera',
            'Fechamento',
            'Recomendação',
        ]
    },
    getters: {
        /* Gerais */
        tabActived(state) {
            return state.tabActived
        },
        loading(state) {
            return state.loading
        },

        /* Stats */
        stats(state) {
            return state.stats
        },
       
        /* Automations */
        automations(state) {
            return state.automations
        },
        periodScopes(state) {
            return state.periodScopes
        },
        periodScope(state) {
            return state.periodScope
        },
        funnelsLast24h(state) {
            return state.funnelsLast24h
        },
        funnelsLastWeek(state) {
            return state.funnelsLastWeek
        },
        campaignsLast24h(state) {
            return state.campaignsLast24h
        },
        campaignsLastWeek(state) {
            return state.campaignsLastWeek
        },

        /* Downloads Stats */
        downloadsStats(state) {
            return state.downloadsStats
        },

        /* Records */
        getRecords(state) { 
            return (payload) => {
                return state[payload]
            }
        },

        /* Log */
        log(state) {
            return state.log
        },
    },
    mutations: {
        /* Gerais */
        setTabActived(state, payload) {
            state.tabActived = payload
        }, 
        setLoading(state, payload) {
            state.loading = payload
        }, 

        /* Automations */
        setPeriodScope(state, payload) {
            state.periodScope = payload
        },

        /* Records */
        setRecords(state, { scope, payload }) {
            state[scope] = payload
        }, 
        updateRecords(state, { scope, payload }) {
            if (Array.isArray(state[scope])) { 
                const index = (state[scope]) ? state[scope].findIndex(p => p._id == payload._id) : -1
                if (index > -1) {
                    state[scope].splice(index, 1, payload)
                } else {
                    state[scope].unshift(payload)
                } 
            } else {
                state[scope] =  payload
            }
        },
        removeRecords(state, { scope, payload }) {
            const index = state[scope].findIndex(p => p._id == payload._id)
            state[scope].splice(index, 1)
        },
    },
    actions: {
        /* Gerais */
        getTabActived({ commit }, payload) {
            commit('setTabActived', payload)
        }, 
      
        /* Records */
        loadRecords({ dispatch, commit }, { scope, path, query, segment, childrenId }) {
            return new Promise(async (resolve, reject) => {
                let methodAxios = 'get'
                let url = `${baseApiUrl}/${path}`
                if (segment) url += `/${segment}` 
                if (query) url += `?${query}` 
                axios[methodAxios](url)
                    .then(async res => {
                        if (res.status === 200) { 
                            let payload = (res.data.hasOwnProperty('data')) ? res.data.data : res.data
                            await dispatch('preProcess', { scope, childrenId, payload, methodAxios })
                            commit('setRecords', { scope, payload }) 
                            await dispatch('posProcess', { scope, childrenId, payload, methodAxios })
                        }
            
                        resolve(res)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },
        saveRecords({ dispatch, commit }, { scope, arrayChilds, path, payload, importer = false }) {
            return new Promise(async (resolve, reject) => {
                let methodAxios = 'post'
                let id = ''
                let options = ''
                
                const preProcess = await dispatch('preProcess', { scope, arrayChilds, payload, methodAxios })
                payload = preProcess.payload
                methodAxios = preProcess.methodAxios
                if (payload.hasOwnProperty("_id")) {
                    id = payload._id
                    methodAxios = 'patch'
                }
                if (payload.files) {
                    options = { headers: {'Content-Type': 'multipart/form-data'} } 

                    const form = new FormData();
                    for (const key in payload) {
                        switch (key) {
                            case 'files':
                                payload[key].forEach(el => form.append(key,el))
                                break;
                            default:
                                form.append(key,stringify(payload[key]))
                                break;
                        }
                    }
                    payload = form
                }
                if (importer) { 
                    if (!payload.hasOwnProperty('file')) { reject('Arquivo não selecionado!'); return }
                    path += '/import' 
                }
                
                const url = `${baseApiUrl}/${path}/${id}`
                axios[methodAxios](url, payload, options)
                    .then(async res => {
                        if (res.status === 200) {
                            // if (methodAxios == 'post') { payload = res.data }
                            let payload = (res.data.hasOwnProperty('data')) ? res.data.data : res.data
                            commit('updateRecords', { scope, payload })
                            await dispatch('posProcess', { scope, payload, methodAxios })
                            // dispatch('updateStats')
                        }
                        resolve(res)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        }, 
        removeRecords({ dispatch, commit }, { scope, arrayChilds, path, payload }) {
            return new Promise(async (resolve, reject) => {
                let methodAxios = 'delete'
                
                const preProcess = await dispatch('preProcess', { scope, arrayChilds, payload, methodAxios })
                payload = preProcess.payload
                methodAxios = preProcess.methodAxios
                
                const url = `${baseApiUrl}/${path}/${payload._id}`
                
                axios[methodAxios](url, payload)
                    .then(async res => {
                        commit('removeRecords', { scope, payload })
                        await dispatch('posProcess', { scope, payload, methodAxios })
                        resolve(res)
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
        },   
        
        /* Processors */
        preProcess ({ dispatch, commit, state }, { scope, arrayChilds = [], payload, methodAxios }) {
            return new Promise(async (resolve, reject) => {
                switch (scope) {
                    case 'funnelsLast24h': case 'funnelsLastWeek':
                        payload.forEach((el, ix) => {
                            let [ newEntries, newExits, newHiddens ] = [0,0,0]
                            el.data.forEach((el2, ix2, array2) => {
                                newEntries += el2.newEntered = el2.entered - ((array2[ix2+1]) ? array2[ix2+1].entered : el2.entered)
                                newExits += el2.newExited = el2.exited - ((array2[ix2+1]) ? array2[ix2+1].exited : el2.exited)
                                newHiddens += el2.newHidden = el2.hidden - ((array2[ix2+1]) ? array2[ix2+1].hidden : el2.hidden)
                      
                                el.data[ix2] = el2
                            })
                            
                            el.current = el.data[0].current
                            el.expectedOffers = el.data[0].expectedOffers
                            el.newEntries = newEntries
                            el.newExits = newExits
                            el.newHiddens = newHiddens
                            payload[ix] = el
                        })
                        break;
                    case 'campaignsLast24h': case 'campaignsLastWeek':
                        payload.forEach((el, ix) => {
                            let [ newSends, newOpens, newClicks ] = [0,0,0]
                            el.data.forEach((el2, ix2, array2) => {
                                newSends += el2.newSends = el2.send_amt - ((array2[ix2+1]) ? array2[ix2+1].send_amt : el2.send_amt)
                                newOpens += el2.newOpens = el2.uniqueopens - ((array2[ix2+1]) ? array2[ix2+1].uniqueopens : el2.uniqueopens)
                                newClicks += el2.newClicks = el2.uniquelinkclicks - ((array2[ix2+1]) ? array2[ix2+1].uniquelinkclicks : el2.uniquelinkclicks)
                      
                                el.data[ix2] = el2
                            })
                            
                            el.sends = el.data[0].send_amt
                            el.opens = el.data[0].uniqueopens
                            el.clicks = el.data[0].uniquelinkclicks
                            el.newSends = newSends
                            el.newOpens = newOpens
                            el.newClicks = newClicks
                            payload[ix] = el
                        })
                        break;
                    default:
                       break;
                }
                resolve({payload, methodAxios});
            })
        }, 
        posProcess ({ commit }, { scope, childrenId = '', payload, methodAxios}) {
            return new Promise((resolve, reject) => {
                switch (scope) {
                    default:
                        break;
                }
                resolve()
            })
        },  
        // updateStats({ dispatch, commit }) {
        //     return new Promise(async (resolve, reject) => {
        //         const url = `${baseApiUrl}/stats/update`
        //         axios.get(url)
        //             .then(async res => {
        //                 dispatch('loadRecords', {scope: 'stats', path: 'stats', segment: '' })
        //                 resolve()
        //             })
        //             .catch((error) => {
        //                 reject(error)
        //             })
        //     })
        // },
    }
}